module.exports = "export default __webpack_public_path__ + &quot;90d41ae81cd2befb89d5748aeb4a55d7.svg&quot;;"